import { MOBILITY_DEFAULT_CURRENCY_CODE } from '@bos/mobility-ui';
import { lazyRouteComponent, createRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MobilityScopeV5x4 } from '../../../../../api/generated/cz.partners.bank.backofficegateway.mobility';
import { clientAccountsPageValidateSearchSchema } from '../../../products/ClientAccountsPage/route';
import { createIncomingMobilityRoute } from '../route';

const createIncomingMobilityBasicInfoRouteSearchSchema =
	clientAccountsPageValidateSearchSchema.extend({
		otherBankPrefix: z.string().optional(),
		otherBankAccount: z.string().optional(),
		otherBankCode: z.string().optional(),
		otherBankCurrencyCode: z.enum([MOBILITY_DEFAULT_CURRENCY_CODE]).optional(),
		date: z.coerce.date().optional(),
		scope: z.array(z.enum(MobilityScopeV5x4)).optional(),
		accountUuid: z.string(),
	});

export type CreateIncomingMobilityBasicInfoRouteSearchSchema = z.infer<
	typeof createIncomingMobilityBasicInfoRouteSearchSchema
>;

export const createIncomingMobilityBasicInfoRoute = createRoute({
	getParentRoute: () => createIncomingMobilityRoute,
	path: '/0-basic-info',
	component: lazyRouteComponent(
		() => import('./CreateIncomingMobilityBasicInfoPage'),
		'CreateIncomingMobilityBasicInfoPage',
	),
	validateSearch: createIncomingMobilityBasicInfoRouteSearchSchema,
});
